module.exports = __webpack_public_path__ + "img/10.a96b107d.jpg";